/* Alix Match — kaydır-beğen makyaj bileşeni.
   Kök: <div class="amx" data-alix-match data-mod="prototip|tema" data-veri="<json url>" data-sepet="/cart"></div>
   Veri: window.ALIX_VERI (prototip) ya da data-veri adresi (tema).
   Tema kipinde fiyat ve stok /products/<handle>.js'ten o anda okunur, sepete /cart/add.js ile eklenir. */
(function () {
  "use strict";
  const kok = document.querySelector("[data-alix-match]");
  if (!kok) return;
  const MOD = kok.dataset.mod || "prototip";
  const ANAHTAR = "alix-match-v1";
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const tl = n => n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ | /g, " ") + " TL";
  const boyut = (u, w) => !u ? "" : /^(https?:)?\/\//.test(u) ? u + (u.includes("?") ? "&" : "?") + "width=" + w : u;
  const azHareket = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
  const SVG = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    kalp: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.5-9.2C1.2 8.7 3.3 5 6.9 5c2 0 3.4 1 5.1 3 1.7-2 3.1-3 5.1-3 3.6 0 5.7 3.7 4.4 6.8C19.5 16.4 12 21 12 21z"/></svg>',
    geri: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:20px;height:20px" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 010 12h-3"/></svg>',
    buyutec: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8v6M8 11h6"/></svg>'
  };

  async function veriAl() {
    if (window.ALIX_VERI) return Object.assign({}, window.ALIX_VERI, window.ALIX_VERI_EK || {});
    const r = await fetch(kok.dataset.veri, { credentials: "same-origin" });
    if (!r.ok) throw new Error("veri " + r.status);
    return r.json();
  }

  veriAl().then(baslat).catch(() => {
    kok.innerHTML = '<p class="amx-bos" style="padding:40px 16px">Görünümler şu an yüklenemedi. Sayfayı yenileyip tekrar dene.</p>';
  });

  function baslat(V) {
    const GK = V.gorselKok || "g/";
    // tema kipinde görünüm başına TEK dosya var (CDN ?width= ile küçültülür); prototipte ayrı -buyuk kopya.
    const LOOKS = V.looks.map(l => Object.assign({ gorsel: GK + l.slug + ".jpg", gorselBuyuk: GK + l.slug + (V.tekGorsel ? ".jpg" : "-buyuk.jpg") }, l));
    const URUN = V.urunler;
    const BYSLUG = Object.fromEntries(LOOKS.map(l => [l.slug, l]));

    // ---- durum yalnız bu sayfa açıkken yaşar: beğenilen de geçilen de yenilemede/kapatmada sıfırlanır.
    // (Eskiden beğeniler localStorage'da kalıyor, geçilenler kalmıyordu; iki taraf ayrı davranıyordu.)
    // Ekranda bu açıkça yazılı (amx-uyari) ve seçim varken yenileme/kapatma tarayıcı onayı ister.
    let K = { begenilen: [], secim: {}, haric: [], eslesmeGoruldu: false };
    try { localStorage.removeItem(ANAHTAR); } catch (e) {}   // eski sürümden kalan kalıcı kaydı temizle
    // Tarif bölümü (sunucuda basılı 100 makale): başta yalnız örnekler görünür; sağa atılan her görünümün tarifi en üste gelir.
    // "kaydet" durum değiştiren her yoldan (karar, geri al, destede geri, sıfırla, seçim) çağrılır → tarif listesi oradan güncellenir.
    function rehberGuncelle() {
      const liste = document.querySelector(".amx-tarif-liste"); if (!liste) return;
      const begen = new Set(K.begenilen);
      for (const a of liste.querySelectorAll(".amx-tarif")) {
        const slug = a.id.replace(/^tarif-/, "");
        a.hidden = !(begen.has(slug) || a.dataset.zorla || ("ornek" in a.dataset && !begen.size));
      }
      for (const slug of K.begenilen) { const a = document.getElementById("tarif-" + slug); if (a) liste.prepend(a); }  // en son beğenilen en üstte
      const g = document.querySelector("[data-rehber-giris]");
      if (g) g.textContent = begen.size
        ? `Sağa attığın ${begen.size} görünümün adım adım tarifi ve ürünleri. Yeni bir görünüme kalp attıkça tarifi buraya eklenir.`
        : g.dataset.ilk;
    }
    const kaydet = () => rehberGuncelle();
    // kart arkasındaki "Adım adım tarifi oku": beğenilmemiş olsa da o tarifi aç, sonra bağlantı oraya kaysın
    document.addEventListener("click", e => {
      const a = e.target.closest('a[href^="#tarif-"]'); if (!a) return;
      const t = document.getElementById(a.getAttribute("href").slice(1)); if (t) { t.dataset.zorla = "1"; t.hidden = false; }
    }, true);

    // Fisher-Yates + kripto rastgelelik: her ziyaretçi, her açılışta farklı sıra görür
    function kar(a) {
      const b = a.slice(), r = new Uint32Array(b.length);
      (window.crypto || window.msCrypto).getRandomValues(r);
      for (let i = b.length - 1; i > 0; i--) { const j = r[i] % (i + 1); [b[i], b[j]] = [b[j], b[i]]; }
      return b;
    }
    let deste = kar(LOOKS.map(l => l.slug).filter(s => !K.begenilen.includes(s)));
    let gecilen = [];          // sola atılanlar (beğenilenlerle aynı: sayfa yenilenince ikisi de sıfırlanır)
    // seçim varken yenile/kapat → tarayıcının kendi "sayfadan ayrıl?" onayı (iOS Safari bunu göstermeyebilir; not ekranda yazılı)
    window.addEventListener("beforeunload", e => { if (K.begenilen.length || gecilen.length) { e.preventDefault(); e.returnValue = ""; } });
    const gecmis = [];         // geri alma için

    // ---- iskelet
    kok.innerHTML = `
      <div class="amx-sahne">
        <header class="amx-ust">
          <div><h1>Alix Match</h1><p>Beğendiğin görünümü sağa, geçmek istediğini sola kaydır.</p></div>
          <button class="amx-sec-btn" data-is="sec" data-amx="secBtn" hidden>Ürünleri seç</button>
          <p class="amx-sec-ipucu" data-amx="secIpucu">Beğendiğin görünümlerin ürünleri burada toplanır</p>
        </header>
        <div class="amx-orta">
          <aside class="amx-yan amx-sol" aria-label="Geçtiklerin"><h3>Geçtiklerin</h3><div class="amx-yan-kartlar" data-amx="yanSol"></div></aside>
          <div class="amx-deste" data-amx="deste" aria-live="polite"></div>
          <aside class="amx-yan amx-sag" aria-label="Beğendiklerin"><h3>Beğendiklerin</h3><div class="amx-yan-kartlar" data-amx="yanSag"></div></aside>
          <div class="amx-kontrol">
            <button class="amx-yigin amx-sol" data-is="yigin" data-taraf="sol" data-amx="yiginSol"></button>
            <div class="amx-dugmeler">
              <button class="amx-gec" data-is="gec" aria-label="Geç">${SVG.x}</button>
              <button class="amx-geri" data-is="geriAl" aria-label="Son kartı geri al">${SVG.geri}</button>
              <button class="amx-begen" data-is="begen" aria-label="Beğen">${SVG.kalp}</button>
            </div>
            <button class="amx-yigin amx-sag" data-is="yigin" data-taraf="sag" data-amx="yiginSag"></button>
          </div>
          <p class="amx-ipucu">Ürünleri görmek için karta dokun. Biriken kartlara dokunursan geri gelirler.</p>
          <p class="amx-uyari">Seçtiklerin kaydedilmez: sayfayı yenilersen ya da kapatırsan hepsi sıfırlanır.</p>
          <button class="amx-sifirla" data-is="sifirla">${SVG.geri}<span>Seçtiklerimi sıfırla</span></button>
        </div>
      </div>
      <div class="amx-perde" data-amx="perde"></div>
      <section class="amx-panel" data-amx="panel" tabindex="-1" role="dialog" aria-modal="true">
        <div class="amx-panel-bas"><h2 data-amx="panelBaslik"></h2><button class="amx-kapat" data-is="kapat" aria-label="Kapat">${SVG.x}</button></div>
        <div class="amx-panel-govde" data-amx="panelGovde"></div>
        <div class="amx-panel-alt" data-amx="panelAlt"></div>
      </section>
      <div class="amx-zoom" data-amx="zoom" role="dialog" aria-modal="true" aria-label="Görseli yakınlaştır">
        <img data-amx="zoomImg" alt="">
        <button class="amx-kapat" data-is="zoomKapat" aria-label="Kapat">${SVG.x}</button>
        <p class="amx-zoom-not">İki parmakla ya da çift dokunarak yakınlaştır</p>
      </div>
      <div class="amx-bildirim" data-amx="bildirim" role="status"></div>`;
    const $ = ad => kok.querySelector(`[data-amx="${ad}"]`);
    // panel/zoom/bildirim temanın taşma ve dönüşüm kurallarından etkilenmesin diye gövdeye taşınır
    ["perde", "panel", "zoom", "bildirim"].forEach(a => { const el = $(a); el.classList.add("amx"); document.body.appendChild(el); });
    const $$ = ad => document.querySelector(`[data-amx="${ad}"]`);

    // ---- bildirim + espriler
    // bilgi mesajı üstte kısa; espri ekranın ortasında, kart üstünde okunur (dokunmayı engellemez)
    function bildir(m, espri) {
      const b = $$("bildirim"); clearTimeout(bildir.t); clearTimeout(bildir.g);
      const goster = () => {
        b.textContent = m; b.classList.toggle("amx-espri", !!espri);
        // espri destenin ortasına oturur (ekran dışındaysa görünür alana kıstırılır)
        const d = $("deste").getBoundingClientRect();
        b.style.top = espri ? Math.min(innerHeight - 110, Math.max(110, d.top + d.height / 2)) + "px" : "";
        b.classList.add("amx-acik");
        bildir.t = setTimeout(() => b.classList.remove("amx-acik"), espri ? 2600 : 1300);
      };
      // espri, kalp/çarpı patlaması bitince gelsin, üst üste binmesin
      if (espri && !azHareket()) { b.classList.remove("amx-acik"); bildir.g = setTimeout(goster, 480); } else goster();
    }
    const ESPRI = {
      sagIki: ["İki kalp üst üste. Bu ritim hoşumuza gitti.", "Sağa, yine sağa. Bugün gönlün bol.", "Peş peşe ikinci kalp. Ayna şimdiden heyecanlandı.", "İkide iki. Zevkin sağlam, devam.", "Seri başladı. Sıradaki de kalbi kapacak mı?"],
      solIki: ["İki kere 'yok' dedin. Standartların yüksek, saygı duyduk.", "Sola, yine sola. Kalbini çalacak olan yolda.", "Bu ikisi senlik değildi. Sıradaki şansını deniyor.", "Elek inceldi. Beğenmek için acele yok.", "İki 'geç' üst üste. Ne istediğini biliyorsun."],
      sagSeri: ["{s} kalp üst üste! Gönlün de paletin kadar geniş.", "Beğeni yağmuru. Makyaj çantan buna hazır mı?", "{s} tane art arda sağa. Durmak yok, kalp atmaya devam.", "Bu seri efsane. Parmağın sağa alıştı galiba."],
      solSeri: ["{s} tanesine üst üste hayır. Seçici olmak bir sanattır.", "Henüz kalbini çalan olmadı. Sıradaki şanslı olabilir.", "Zor beğeniyorsun. Biz de öyleyiz.", "{s} kart üst üste sola uçtu. Sol taraf seni çok seviyor."],
      sagCok: ["{n} beğeni! Sağ taraf kalabalıklaştı, ürünlere bakmanın tam zamanı.", "Beğendiklerin {n} oldu. Bu artık bir koleksiyon.", "{n} kalp. Sağdaki yığın makyaj çantandan önce doldu.", "Sağda {n} görünüm birikti. Seçmek zor, biliyoruz."],
      solCok: ["Solda {n} kart birikti. Elemeler bitince kalan efsane olacak.", "{n} görünümü geçtin. Zevk sahibi biri olduğun belli.", "Sol taraf {n} oldu. Fikrin değişirse karta dokunman yeter, geri gelir.", "{n} kere 'bu değil' dedin. Doğrusu yakında karşına çıkar."],
      hizli: ["Bu hızla gidersen rimel kurumadan bitiririz. Biraz yavaşla, yüzler kaçmıyor.", "Kaydırma şampiyonasında birinciliğe oynuyorsun. Bir de bakmayı dene.", "Göz kırpma hızında karar veriyorsun. Kirpik takmaya da bu kadar hızlıysan helal."],
      yavas: ["Kirpik kirpik inceledin. Gerçek bir profesyonelsin.", "Bu dikkatle bakan, allığı elmacık kemiğine tam oturtur.", "Acele etmeyen makyaj sanatçısı gibi baktın. Saygı duyduk."],
      urunlu: ["Ürün listesini de okudun. Sen bu işi biliyorsun.", "Önce içindekiler, sonra karar. Tam bir uzman yaklaşımı."],
      zoomlu: ["Yakından baktın, gözünden hiçbir şey kaçmıyor.", "Bu yakınlıkta ancak bir makyaj sanatçısı bakar."],
      geri: ["Kararsızlık da bir stil. Geri aldık.", "Bir daha bakmak her zaman serbest.", "Fikir değiştirmek kadınların hakkı. Kart geri döndü."]
    };
    // aynı espri arka arkaya gelmesin: her grup karılmış bir torbadan çekilir
    const torba = {};
    function sec(ad, deg) {
      if (!torba[ad] || !torba[ad].length) torba[ad] = kar(ESPRI[ad]);
      let m = torba[ad].pop();
      if (deg) Object.keys(deg).forEach(k => { m = m.split("{" + k + "}").join(deg[k]); });
      return m;
    }
    const SAG_ESIK = [3, 6, 10, 15, 20, 30, 40, 50, 75, 100], SOL_ESIK = [5, 10, 15, 20, 30, 40, 50, 75, 100];
    let espriSon = -9, kartBasladi = performance.now(), kartCevrildi = false, kartZoom = false;
    const hizSerisi = [];
    function espriSec(sure, begendi) {
      hizSerisi.push(sure < 900); if (hizSerisi.length > 3) hizSerisi.shift();
      if (gecmis.length - espriSon < 2) return null;
      let seri = 0;
      for (let i = gecmis.length - 1; i >= 0 && gecmis[i].begendi === begendi; i--) seri++;
      const n = begendi ? K.begenilen.length : gecilen.length;
      let m = null;
      if (hizSerisi.length === 3 && hizSerisi.every(Boolean)) m = sec("hizli");
      else if (kartZoom) m = sec("zoomlu");
      else if (sure > 8000) m = sec(kartCevrildi ? "urunlu" : "yavas");
      else if ((begendi ? SAG_ESIK : SOL_ESIK).includes(n)) m = sec(begendi ? "sagCok" : "solCok", { n });
      else if (seri >= 4 && seri % 2 === 0) m = sec(begendi ? "sagSeri" : "solSeri", { s: seri });
      else if (seri === 2) m = sec(begendi ? "sagIki" : "solIki");
      if (m) { espriSon = gecmis.length; hizSerisi.length = 0; }
      return m;
    }
    // kararın hissi: sağda kalp patlar, solda çarpı sallanır
    function patlat(begendi) {
      const d = $("deste").getBoundingClientRect();
      const el = document.createElement("div");
      el.className = "amx amx-patla " + (begendi ? "amx-patla-kalp" : "amx-patla-x");
      el.setAttribute("aria-hidden", "true");
      el.style.left = d.left + d.width / 2 + "px"; el.style.top = d.top + d.height / 2 + "px";
      el.innerHTML = `<span class="amx-patla-ana">${begendi ? SVG.kalp : SVG.x}</span>` +
        (begendi ? [0, 1, 2, 3, 4, 5].map(i => `<span class="amx-patla-mini" style="--a:${i * 60 + 15}deg">${SVG.kalp}</span>`).join("") : "");
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 800);
      try { navigator.vibrate && navigator.vibrate(begendi ? 14 : [8, 40, 8]); } catch (e) {}
    }
    function sifirla(b) {
      if (!K.begenilen.length && !gecilen.length && !gecmis.length) return bildir("Sıfırlanacak seçim yok");
      if (!b.dataset.onay) {
        b.dataset.onay = "1"; b.lastChild.textContent = "Emin misin? Tekrar dokun";
        clearTimeout(sifirla.t); sifirla.t = setTimeout(() => { delete b.dataset.onay; b.lastChild.textContent = "Seçtiklerimi sıfırla"; }, 3000);
        return;
      }
      clearTimeout(sifirla.t); delete b.dataset.onay; b.lastChild.textContent = "Seçtiklerimi sıfırla";
      K = { begenilen: [], secim: {}, haric: [], eslesmeGoruldu: false }; gecilen = []; gecmis.length = 0;
      document.querySelectorAll(".amx-tarif[data-zorla]").forEach(a => delete a.dataset.zorla);
      deste = kar(LOOKS.map(l => l.slug)); espriSon = -9; hizSerisi.length = 0;
      kaydet(); desteCiz(); bildir("Sıfırlandı. Deste baştan karıldı, kalpler seni bekliyor.", true);
    }

    // ---- kart
    function urunSatiri(u) {
      const p = URUN[u.handle];
      const v = u.varyant ? p.varyantlar.find(x => x.ad === u.varyant) : null;
      const ton = u.tonSec ? "Tonunu sen seçersin" : (v && p.varyantlar.length > 1 ? v.ad : "");
      // alt: ürün + ton adı (görsel aramasında ürün bulunsun); ton seçmeli üründe ürün + tip
      const alt = `Alix Avien ${p.ad}` + (!u.tonSec && v && p.varyantlar.length > 1 ? ` ${v.ad}` : ` ${p.tip}`);
      // yeni sekmede açılır: bu sayfadaki seçimler kaydedilmediği için aynı sekmede gitmek onları siler
      return `<li><a href="${esc(p.url || "/products/" + u.handle)}" target="_blank" rel="noopener"><img src="${esc(boyut((v && v.gorsel) || p.gorsel, 120))}" alt="${esc(alt)}" loading="lazy"><div><b>${esc(p.ad)}</b><span>${esc(p.tip)}${ton ? " · " + esc(ton) : ""}</span></div><i aria-hidden="true">›</i></a></li>`;
    }
    function kartHtml(l) {
      return `<div class="amx-ic">
        <div class="amx-yuz">
          <img src="${esc(boyut(l.gorsel, 1080))}" alt="${esc(l.ad)} makyajı" draggable="false">
          <div class="amx-damga amx-evet">Beğendim</div><div class="amx-damga amx-hayir">Geç</div>
          <div class="amx-yazi"><h2>${esc(l.ad)}</h2><p>${esc(l.ozet)}</p>
            <div class="amx-eylemler"><button class="amx-cam" data-is="cevir" aria-label="Ürünleri gör">Ürünler</button>
            <button class="amx-cam amx-yuvarlak" data-is="zoom" aria-label="Yakınlaştır">${SVG.buyutec}</button></div>
          </div>
        </div>
        <div class="amx-sirt" data-is="cevir" role="button" tabindex="-1" aria-label="Görsele dön">
          <header><h3>${esc(l.ad)}</h3><p>Bu görünüm için önerilen ${l.urunler.length} ürün, uygulama sırasıyla</p>${kok.dataset.mod === "tema" ? `<a href="#tarif-${esc(l.slug)}">Adım adım tarifi oku</a>` : ""}</header>
          <ol class="amx-adimlar">${l.urunler.map(urunSatiri).join("")}</ol>
          <p class="amx-sirt-not">Ürüne dokun, sayfası yeni sekmede açılır. Görsele dönmek için boş bir yere dokun.</p>
        </div>
      </div>`;
    }
    function desteCiz() {
      const d = $("deste"); d.innerHTML = "";
      if (!deste.length) {
        d.innerHTML = `<div class="amx-bitti"><div><h2>Hepsine baktın</h2><p>${K.begenilen.length ? K.begenilen.length + " görünüm beğendin. Ürünlerini tek ekranda seçebilirsin." : "Henüz bir görünüm beğenmedin."}</p>
          ${K.begenilen.length ? `<button class="amx-ana" data-is="sec">Ürünleri seç</button>` : ""}
          ${gecilen.length ? `<button class="amx-ikincil" data-is="gecilenleriDondur" style="margin-top:10px">Geçtiklerimi tekrar göster</button>` : ""}</div></div>`;
      } else {
        deste.slice(0, 2).reverse().forEach((slug, i, a) => {
          const el = document.createElement("div");
          const ust = i === a.length - 1;
          el.className = "amx-kart" + (ust ? "" : " amx-arka");
          el.dataset.slug = slug;
          el.innerHTML = kartHtml(BYSLUG[slug]);
          if (!ust) el.setAttribute("aria-hidden", "true");
          d.appendChild(el);
        });
        surukle(d.lastElementChild);
        // sıradaki kartın görselini önceden yükle
        if (deste[2]) { const im = new Image(); im.src = boyut(BYSLUG[deste[2]].gorsel, 1080); }
      }
      kartBasladi = performance.now(); kartCevrildi = false; kartZoom = false;
      yiginCiz();
    }
    function miniHtml(s, taraf, etiket) {
      return `<button class="amx-mini" data-is="dondur" data-slug="${s}" data-taraf="${taraf}" aria-label="${esc(BYSLUG[s].ad)} desteye geri getir"><img src="${esc(boyut(BYSLUG[s].gorsel, 300))}" alt="" loading="lazy"><span>${esc(BYSLUG[s].ad)}</span>${etiket ? `<em>${etiket}</em>` : ""}</button>`;
    }
    function yiginCiz() {
      [["sol", gecilen, "Geçtin"], ["sag", K.begenilen, "Beğendin"]].forEach(([t, liste, ad]) => {
        const b = $(t === "sol" ? "yiginSol" : "yiginSag");
        const son = liste.slice(-3);
        b.innerHTML = `<span class="amx-yigin-kartlar">${son.length ? son.map(s => `<img src="${esc(boyut(BYSLUG[s].gorsel, 160))}" alt="">`).join("") : `<span class="amx-yigin-bos"></span>`}</span><span class="amx-yigin-sayi"><b>${liste.length}</b>${ad}</span>`;
        b.setAttribute("aria-label", `${ad}: ${liste.length} görünüm. Dokununca açılır.`);
        const yan = $(t === "sol" ? "yanSol" : "yanSag");
        yan.innerHTML = liste.length ? liste.slice().reverse().map(s => miniHtml(s, t)).join("") : `<div class="amx-yan-bos">${t === "sol" ? "Sola attıkların burada birikir" : "Sağa attıkların burada birikir"}</div>`;
      });
      $("secBtn").hidden = !K.begenilen.length; $("secIpucu").hidden = !!K.begenilen.length;
      $("secBtn").textContent = K.begenilen.length ? `Ürünleri seç (${K.begenilen.length})` : "Ürünleri seç";
    }

    // ---- sürükleme
    function surukle(kart) {
      let x0 = 0, y0 = 0, dx = 0, dy = 0, t0 = 0, basili = false;
      const ic = kart.querySelector(".amx-ic"), evet = kart.querySelector(".amx-evet"), hayir = kart.querySelector(".amx-hayir");
      kart.addEventListener("pointerdown", e => {
        if (e.target.closest("button") || kart.classList.contains("amx-cevrik")) return;
        basili = true; x0 = e.clientX; y0 = e.clientY; dx = dy = 0; t0 = performance.now();
        kart.setPointerCapture(e.pointerId); ic.style.transition = "none";
      });
      kart.addEventListener("pointermove", e => {
        if (!basili) return;
        dx = e.clientX - x0; dy = e.clientY - y0;
        ic.style.transform = `translate(${dx}px,${dy * .3}px) rotate(${dx / 18}deg)`;
        evet.style.opacity = Math.max(0, Math.min(1, dx / 90)); hayir.style.opacity = Math.max(0, Math.min(1, -dx / 90));
      });
      const birak = () => {
        if (!basili) return; basili = false; ic.style.transition = "";
        const hiz = Math.abs(dx) / Math.max(1, performance.now() - t0);
        if (Math.abs(dx) > 110 || (Math.abs(dx) > 40 && hiz > .6)) return karar(dx > 0);
        ic.style.transform = ""; evet.style.opacity = hayir.style.opacity = 0;
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) { kartCevrildi = true; kart.classList.add("amx-cevrik"); }
      };
      kart.addEventListener("pointerup", birak); kart.addEventListener("pointercancel", birak);
    }
    function karar(begendi) {
      if (!deste.length) return;
      const kart = $("deste").lastElementChild, slug = deste[0];
      const ic = kart && kart.querySelector(".amx-ic");
      if (ic) {
        ic.style.transition = "transform .35s ease-in";
        ic.style.transform = `translate(${begendi ? 520 : -520}px,30px) rotate(${begendi ? 22 : -22}deg)`;
        const d = kart.querySelector(begendi ? ".amx-evet" : ".amx-hayir"); if (d) d.style.opacity = 1;
      }
      const sure = performance.now() - kartBasladi;
      deste.shift();
      gecmis.push({ slug, begendi });
      if (begendi) { if (!K.begenilen.includes(slug)) K.begenilen.push(slug); } else gecilen.push(slug);
      kaydet();
      patlat(begendi);
      const espri = espriSec(sure, begendi);
      if (espri) bildir(espri, true); else if (begendi) bildir(BYSLUG[slug].ad + " beğendiklerine eklendi");
      setTimeout(() => {
        desteCiz();
        if (begendi && K.begenilen.length >= 4 && !K.eslesmeGoruldu) { K.eslesmeGoruldu = true; kaydet(); begenilenlerAc(true); }
      }, azHareket() ? 0 : 320);
    }
    function geriAl() {
      const s = gecmis.pop(); if (!s) return bildir("Geri alınacak kart yok");
      K.begenilen = K.begenilen.filter(x => x !== s.slug); gecilen = gecilen.filter(x => x !== s.slug);
      deste = [s.slug].concat(deste.filter(x => x !== s.slug));
      kaydet(); desteCiz();
      if (Math.random() < .5) bildir(sec("geri"), true);
    }
    function dondur(slug) {
      K.begenilen = K.begenilen.filter(x => x !== slug); gecilen = gecilen.filter(x => x !== slug);
      deste = [slug].concat(deste.filter(x => x !== slug));
      kaydet(); panelKapat(); desteCiz();
      bildir(BYSLUG[slug].ad + " yeniden destede");
    }

    // ---- panel
    let donus = null;
    function panelAc(baslik, govde, alt) {
      donus = document.activeElement;
      $$("panelBaslik").textContent = baslik; $$("panelGovde").innerHTML = govde; $$("panelAlt").innerHTML = alt || "";
      $$("bildirim").classList.remove("amx-acik"); $$("perde").classList.add("amx-acik"); $$("panel").classList.add("amx-acik");
      $$("panel").focus({ preventScroll: true });
    }
    function panelKapat() {
      $$("perde").classList.remove("amx-acik"); $$("panel").classList.remove("amx-acik");
      if (donus && donus.focus && document.contains(donus)) donus.focus({ preventScroll: true });
    }
    function stilHtml() {
      const say = {}; K.begenilen.forEach(s => { const k = BYSLUG[s].stil || "Diğer"; say[k] = (say[k] || 0) + 1; });
      const top = K.begenilen.length;
      return `<div class="amx-stil"><p>Beğendiklerine göre stilin</p>${Object.entries(say).sort((a, b) => b[1] - a[1]).map(([k, n]) => {
        const y = Math.round(n / top * 100);
        return `<div class="amx-stil-satir"><span>${esc(k)}</span><span class="amx-stil-bar"><i style="width:${y}%"></i></span><span>%${y}</span></div>`; }).join("")}</div>`;
    }
    function begenilenlerAc(eslesme) {
      if (!K.begenilen.length) return panelAc("Beğendiklerin", `<p class="amx-bos">Henüz bir görünüm beğenmedin. Hoşuna gidenleri sağa kaydır, burada birikir.</p>`, `<button class="amx-ikincil" data-is="kapat">Kaydırmaya dön</button>`);
      const govde = stilHtml() + `<p class="amx-cip-not">Bir görünüme dokunursan beğendiklerinden çıkar ve desteye geri döner.</p><div class="amx-izgara">${K.begenilen.slice().reverse().map(s => miniHtml(s, "sag", "Desteye dön")).join("")}</div>`;
      panelAc(eslesme ? "Stilin belli oluyor" : "Beğendiklerin", govde,
        `<button class="amx-ana" data-is="sec">Bu görünümlerin ürünlerini seç</button>${eslesme ? `<button class="amx-ikincil" style="margin-top:8px" data-is="kapat">Kaydırmaya devam et</button>` : ""}`);
    }
    function gecilenlerAc() {
      if (!gecilen.length) return panelAc("Geçtiklerin", `<p class="amx-bos">Henüz bir görünümü geçmedin. Sola attıkların burada birikir, dokununca geri gelir.</p>`, "");
      panelAc("Geçtiklerin", `<p class="amx-cip-not">Fikrini mi değiştirdin? Bir görünüme dokun, desteye geri dönsün.</p><div class="amx-izgara">${gecilen.slice().reverse().map(s => miniHtml(s, "sol", "Desteye dön")).join("")}</div>`, "");
    }

    // ---- birleşik ürün seçimi
    function birlesik() {
      const m = new Map();
      K.begenilen.filter(s => !K.haric.includes(s)).forEach(s => BYSLUG[s].urunler.forEach(u => {
        if (!m.has(u.handle)) m.set(u.handle, { handle: u.handle, tonSec: u.tonSec, oneri: u.varyant, gorunumler: [] });
        m.get(u.handle).gorunumler.push(BYSLUG[s].ad);
      }));
      return [...m.values()];
    }
    function durum(k) {
      const p = URUN[k.handle];
      let s = K.secim[k.handle];
      if (!s) {
        const tek = p.varyantlar.length === 1 ? p.varyantlar[0].id : null;
        const oneri = k.oneri ? (p.varyantlar.find(v => v.ad === k.oneri) || {}).id : null;
        s = K.secim[k.handle] = { acik: true, varyant: k.tonSec ? null : (oneri || tek) };
      }
      // tükenmiş bir ton seçili kaldıysa seçimi boşalt: tükenmiş varyant sepete gönderilmez
      const v = p.varyantlar.find(x => x.id === s.varyant);
      if (v && !v.stok) s.varyant = null;
      return s;
    }
    function cipler() {
      const dahil = K.begenilen.filter(s => !K.haric.includes(s)).length;
      return `<div class="amx-cipler" role="group" aria-label="Sepete dahil görünümler">${K.begenilen.map(s => `<button class="amx-cip" data-is="dahil" data-slug="${s}" aria-pressed="${!K.haric.includes(s)}"><img src="${esc(boyut(BYSLUG[s].gorsel, 120))}" alt="">${esc(BYSLUG[s].ad)}</button>`).join("")}</div>
        <p class="amx-cip-not">${dahil} / ${K.begenilen.length} görünüm dahil. Bir görünüme dokununca ürünleri listeden çıkar ya da geri gelir.</p>`;
    }
    // ürün sayfası adresi: seçili ton varsa o tonla açılır (Shopify ?variant=)
    function urunAdres(h, v) {
      const p = URUN[h], u = p.url || "/products/" + h;
      return v && p.varyantlar.length > 1 ? u + (u.includes("?") ? "&" : "?") + "variant=" + v.id : u;
    }
    const urunAlt = (p, v) => `Alix Avien ${p.ad} ` + (v && p.varyantlar.length > 1 ? v.ad : p.tip);
    function secimGovde() {
      const liste = birlesik();
      if (!liste.length) return cipler() + `<p class="amx-bos">Hiç görünüm seçili değil. Yukarıdan en az bir görünümü dahil et.</p>`;
      return cipler() + `<p style="margin:0 0 6px;color:var(--soluk);font-size:14px">Bu görünümlerde ${liste.length} ürün var. Elinde olanların işaretini kaldır, ten tonu gereken ürünlerde kendi tonunu seç.</p>` +
        liste.map(k => {
          const p = URUN[k.handle], s = durum(k), v = p.varyantlar.find(x => x.id === s.varyant);
          const hepsiTukendi = !p.varyantlar.some(x => x.stok);
          const secenek = p.varyantlar.length > 1 ? `<select data-handle="${k.handle}" aria-label="${esc(p.ad)} tonu" class="${s.acik && !s.varyant ? "amx-eksik" : ""}">
              <option value="">${k.tonSec ? "Tonunu seç" : "Ton seç"}</option>
              ${p.varyantlar.map(x => `<option value="${x.id}" ${x.id === s.varyant ? "selected" : ""} ${x.stok ? "" : "disabled"}>${esc(x.ad)}${x.stok ? "" : " (tükendi)"}${k.oneri === x.ad ? " · görünümdeki ton" : ""}</option>`).join("")}</select>` : "";
          const f = v || p.varyantlar[0];
          return `<div class="amx-urun ${s.acik ? "" : "amx-kapali"}">
            <input type="checkbox" data-handle="${k.handle}" ${s.acik ? "checked" : ""} ${hepsiTukendi ? "disabled" : ""} aria-label="${esc(p.ad)} sepete eklensin">
            <a class="amx-urun-git" href="${esc(urunAdres(k.handle, v))}" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true"><img src="${esc(boyut((v && v.gorsel) || p.gorsel, 120))}" alt="${esc(urunAlt(p, v))}" loading="lazy"></a>
            <div><b><a class="amx-urun-git" href="${esc(urunAdres(k.handle, v))}" target="_blank" rel="noopener">${esc(p.ad)}<span aria-hidden="true"> ›</span></a>${k.gorunumler.length > 1 ? `<span class="amx-rozet">${k.gorunumler.length} görünümde</span>` : ""}</b>
            <div class="amx-alt">${esc(p.tip)} · ${esc(k.gorunumler.join(", "))}${hepsiTukendi ? " · şu an tükendi" : ""}</div>${secenek}
            <div class="amx-fiyat">${f.eski && f.eski > f.fiyat ? `<s>${tl(f.eski)}</s>` : ""}${tl(f.fiyat)}</div></div></div>`;
        }).join("");
    }
    function altCiz() {
      const liste = birlesik();
      const secili = liste.filter(k => K.secim[k.handle] && K.secim[k.handle].acik && URUN[k.handle].varyantlar.some(x => x.stok));
      const eksik = secili.filter(k => !K.secim[k.handle].varyant);
      const toplam = secili.reduce((t, k) => { const v = URUN[k.handle].varyantlar.find(x => x.id === K.secim[k.handle].varyant); return t + (v ? v.fiyat : 0); }, 0);
      return `<div class="amx-toplam"><span>${secili.length} ürün · indirimler sepette uygulanır</span><strong>${tl(toplam)}</strong></div>
        <p class="amx-hata" data-amx="hata">${eksik.length ? eksik.length + " üründe ton seçmen gerekiyor." : ""}</p>
        <button class="amx-ana" data-is="sepete" ${!secili.length || eksik.length ? "disabled" : ""}>${secili.length ? secili.length + " ürünü sepete ekle" : "Ürün seçmedin"}</button>`;
    }
    // Tema kipinde fiyat ve stok o anda mağazadan okunur; okunamazsa son bilinen değer kalır ve bu söylenir
    async function canliTazele(handles) {
      if (MOD !== "tema") return true;
      let hepsi = true;
      await Promise.all(handles.map(async h => {
        try {
          const r = await fetch(`/products/${encodeURIComponent(h)}.js`, { credentials: "same-origin" });
          if (!r.ok) throw 0;
          const j = await r.json(), p = URUN[h];
          p.varyantlar = j.variants.map(v => ({ id: v.id, ad: v.title, fiyat: v.price / 100, eski: v.compare_at_price ? v.compare_at_price / 100 : null, stok: !!v.available,
            gorsel: (v.featured_image && v.featured_image.src) || (p.varyantlar.find(x => x.id === v.id) || {}).gorsel || null }));
        } catch (e) { hepsi = false; }
      }));
      return hepsi;
    }
    async function secimAc() {
      if (!K.begenilen.length) return begenilenlerAc(false);
      panelAc("Ürünleri seç", `<p class="amx-bos">Güncel fiyat ve stok bilgisi alınıyor…</p>`, "");
      const tamam = await canliTazele(birlesik().map(k => k.handle));
      $$("panelGovde").innerHTML = (tamam ? "" : `<p class="amx-hata">Bazı ürünlerin güncel fiyatı alınamadı; sepette son fiyat görünür.</p>`) + secimGovde();
      $$("panelAlt").innerHTML = altCiz();
    }
    function secimYenile() { const g = $$("panelGovde"), y = g.scrollTop; g.innerHTML = secimGovde(); g.scrollTop = y; $$("panelAlt").innerHTML = altCiz(); }
    async function sepeteEkle(btn) {
      const items = birlesik().filter(k => K.secim[k.handle].acik && K.secim[k.handle].varyant).map(k => ({ id: K.secim[k.handle].varyant, quantity: 1 }));
      if (MOD !== "tema") {
        return panelAc("Sepete gidecek", `<p style="color:var(--soluk);font-size:14px;margin:0 0 10px">Prototipte sepete gönderilmedi. Mağazada bu ${items.length} satır tek istekle sepete eklenir:</p><pre class="amx-yuk">${esc(JSON.stringify({ items }, null, 2))}</pre>`,
          `<button class="amx-ikincil" data-is="sec">Seçime dön</button>`);
      }
      btn.disabled = true; btn.textContent = "Sepete ekleniyor…";
      try {
        const r = await fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.description || j.message || "Sepete eklenemedi");
        location.href = kok.dataset.sepet || "/cart";
      } catch (e) {
        const h = $$("hata"); if (h) h.textContent = "Sepete eklenemedi: " + e.message + ". Seçimini kontrol edip tekrar dene.";
        btn.disabled = false; btn.textContent = items.length + " ürünü sepete ekle";
      }
    }

    // ---- yakınlaştırma
    const Z = { s: 1, x: 0, y: 0, w: 0, h: 0, temel: 1, isaret: new Map(), ilkMesafe: 0, ilkS: 1, son: 0 };
    function zoomAc(slug) {
      const img = $$("zoomImg"); img.alt = BYSLUG[slug].ad + " makyajı yakın plan";
      img.onload = () => { Z.w = img.naturalWidth; Z.h = img.naturalHeight; zoomSigdir(); };
      img.src = boyut(BYSLUG[slug].gorselBuyuk, 2400);
      $$("zoom").classList.add("amx-acik"); $$("zoom").querySelector(".amx-kapat").focus();
    }
    function zoomSigdir() { Z.temel = Math.min(innerWidth / Z.w, innerHeight / Z.h); Z.s = Z.temel; Z.x = -Z.w * Z.s / 2; Z.y = -Z.h * Z.s / 2; zoomUygula(); }
    function zoomUygula() {
      const W = innerWidth, H = innerHeight, gw = Z.w * Z.s, gh = Z.h * Z.s;
      Z.x = gw <= W ? -gw / 2 : Math.min(-W / 2, Math.max(W / 2 - gw, Z.x));
      Z.y = gh <= H ? -gh / 2 : Math.min(-H / 2, Math.max(H / 2 - gh, Z.y));
      const img = $$("zoomImg"); img.style.width = Z.w + "px"; img.style.transform = `translate(${Z.x}px,${Z.y}px) scale(${Z.s})`;
    }
    function zoomOlcek(yeni, cx, cy) {
      yeni = Math.max(Z.temel, Math.min(Z.temel * 5, yeni));
      const px = cx - innerWidth / 2, py = cy - innerHeight / 2;
      Z.x = px - (px - Z.x) * (yeni / Z.s); Z.y = py - (py - Z.y) * (yeni / Z.s); Z.s = yeni; zoomUygula();
    }
    const zb = $$("zoom");
    zb.addEventListener("pointerdown", e => {
      if (e.target.closest("button")) return;
      zb.setPointerCapture(e.pointerId); Z.isaret.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (Z.isaret.size === 2) { const [a, b] = [...Z.isaret.values()]; Z.ilkMesafe = Math.hypot(a.x - b.x, a.y - b.y); Z.ilkS = Z.s; }
      const t = performance.now(); if (Z.isaret.size === 1 && t - Z.son < 300) zoomOlcek(Z.s > Z.temel * 1.1 ? Z.temel : Z.temel * 2.5, e.clientX, e.clientY); Z.son = t;
    });
    zb.addEventListener("pointermove", e => {
      const o = Z.isaret.get(e.pointerId); if (!o) return;
      if (Z.isaret.size === 2) { Z.isaret.set(e.pointerId, { x: e.clientX, y: e.clientY }); const [a, b] = [...Z.isaret.values()]; zoomOlcek(Z.ilkS * Math.hypot(a.x - b.x, a.y - b.y) / Z.ilkMesafe, (a.x + b.x) / 2, (a.y + b.y) / 2); }
      else { Z.x += e.clientX - o.x; Z.y += e.clientY - o.y; Z.isaret.set(e.pointerId, { x: e.clientX, y: e.clientY }); zoomUygula(); }
    });
    const zbBirak = e => Z.isaret.delete(e.pointerId);
    zb.addEventListener("pointerup", zbBirak); zb.addEventListener("pointercancel", zbBirak);
    zb.addEventListener("wheel", e => { e.preventDefault(); zoomOlcek(Z.s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY); }, { passive: false });
    function zoomKapat() { zb.classList.remove("amx-acik"); $$("zoomImg").removeAttribute("src"); }
    addEventListener("resize", () => { if (zb.classList.contains("amx-acik") && Z.w) zoomSigdir(); });

    // ---- olaylar (bileşen + gövdeye taşınan katmanlar)
    function tikla(e) {
      if (e.target.closest("a[href]")) return;   // ürün bağlantısı: kartı çevirme, bağlantı açılsın
      const b = e.target.closest("[data-is]"); if (!b) return;
      const is = b.dataset.is;
      if (is === "cevir") { kartCevrildi = true; b.closest(".amx-kart").classList.toggle("amx-cevrik"); }
      else if (is === "zoom") { kartZoom = true; zoomAc(b.closest(".amx-kart").dataset.slug); }
      else if (is === "begen") karar(true);
      else if (is === "gec") karar(false);
      else if (is === "geriAl") geriAl();
      else if (is === "sifirla") sifirla(b);
      else if (is === "yigin") b.dataset.taraf === "sol" ? gecilenlerAc() : begenilenlerAc(false);
      else if (is === "dondur") dondur(b.dataset.slug);
      else if (is === "gecilenleriDondur") { deste = kar(gecilen); gecilen = []; desteCiz(); }
      else if (is === "sec") secimAc();
      else if (is === "kapat") panelKapat();
      else if (is === "zoomKapat") zoomKapat();
      else if (is === "sepete") sepeteEkle(b);
      else if (is === "dahil") { const s = b.dataset.slug; K.haric = K.haric.includes(s) ? K.haric.filter(x => x !== s) : K.haric.concat(s); kaydet(); secimYenile(); }
    }
    kok.addEventListener("click", tikla);
    [$$("panel"), $$("zoom")].forEach(el => el.addEventListener("click", tikla));
    $$("perde").addEventListener("click", panelKapat);
    $$("panel").addEventListener("change", e => {
      const h = e.target.dataset && e.target.dataset.handle; if (!h || !K.secim[h]) return;
      if (e.target.type === "checkbox") { K.secim[h].acik = e.target.checked; e.target.closest(".amx-urun").classList.toggle("amx-kapali", !e.target.checked); }
      else {
        K.secim[h].varyant = e.target.value ? Number(e.target.value) : null; e.target.classList.toggle("amx-eksik", !e.target.value);
        const v = URUN[h].varyantlar.find(x => x.id === K.secim[h].varyant), satir = e.target.closest(".amx-urun");
        if (v) { satir.querySelector(".amx-fiyat").innerHTML = (v.eski && v.eski > v.fiyat ? `<s>${tl(v.eski)}</s>` : "") + tl(v.fiyat); if (v.gorsel) satir.querySelector("img").src = boyut(v.gorsel, 120); satir.querySelector("img").alt = urunAlt(URUN[h], v); }
        satir.querySelectorAll(".amx-urun-git").forEach(a => a.href = urunAdres(h, v));
      }
      kaydet(); $$("panelAlt").innerHTML = altCiz();
    });
    document.addEventListener("keydown", e => {
      if (e.key === "Escape") { if (zb.classList.contains("amx-acik")) zoomKapat(); else panelKapat(); return; }
      if ($$("panel").classList.contains("amx-acik") || zb.classList.contains("amx-acik") || /input|select|textarea/i.test(e.target.tagName)) return;
      if (!kok.contains(document.activeElement) && document.activeElement !== document.body) return;
      if (e.key === "ArrowRight") karar(true); else if (e.key === "ArrowLeft") karar(false);
    });
    desteCiz(); rehberGuncelle();
  }
})();
